const getters = {
  device: state => state.app.device,

  // 导航序号
  headerIndex: state => state.header.headerIndex,

  winScroll: state => state.header.winScroll,

  pageReloadState: state => state.header.pageReloadState,
  searchStr: state => state.header.searchStr,
  searchFuncState: state => state.header.searchFuncState,

  articleRightId: state => state.header.articleRightId,

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js